// Reverse-geocode a stored "lat, lng" location string to a readable "City,
// Region" via a free, no-key service. Values that are already place names are
// returned as-is. Results are memoized process-wide so re-renders and repeat
// pages don't re-hit the API.
const cache = new Map();
const COORD = /^\s*(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)\s*$/;

export default async function reverseGeocode(loc) {
  if (!loc) return null;
  if (cache.has(loc)) return cache.get(loc);
  const m = COORD.exec(loc);
  if (!m) {
    cache.set(loc, loc); // already a place name
    return loc;
  }
  try {
    const [, lat, lng] = m;
    const r = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lng}&localityLanguage=en`
    );
    const d = await r.json();
    const city = d.city || d.locality || d.principalSubdivision;
    const region = d.principalSubdivision || d.countryName;
    const label = city ? (region && region !== city ? `${city}, ${region}` : city) : loc;
    cache.set(loc, label);
    return label;
  } catch {
    cache.set(loc, loc);
    return loc;
  }
}
